<template>
  <div class="home-page">
    <main-slider
      class="home-page__slider"
    />
    <div class="container">
      <banners-slot
        :with-category="false"
        slot-name="rowbanner2_main"
        class="home-page__rowbanner2"
      />

      <banners-slot
        :with-category="false"
        slot-name="rowbanner4_main"
        class="bottom-offset"
      />

      <product-gallery-slot
        :with-category="false"
        slot-name="popular_main"
        class="home-page__popular_main"
      />

      <banners-slot
        :with-category="false"
        class="home-page__bottom-offset"
        slot-name="rowbanner1_main"
      />

      <banners-slot
        :with-category="false"
        class="home-page__bottom-offset"
        slot-name="rowbanner3_main"
      />

      <banners-slot
        :with-category="false"
        class="bottom-offset"
        slot-name="rowbanner5_main"
      />

      <product-gallery-slot
        :with-category="false"
        class="bottom-offset"
        slot-name="new_main"
      />

      <category-banners
        :with-category="false"
        slot-name="category_main"
      />

      <advantages
        class="home-page__advantages"
      />

      <publications-block
        link
        title="Новости и акции"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* Components */
import MainSlider from '@/components/home/slider'
import BannersSlot from '@/components/banners-slot/banners-slot.vue';
import ProductGallerySlot from '@/components/product-gallery-slot/product-gallery-slot.vue';
import CategoryBanners from '@/components/category-banners/category-banners.vue';
import Advantages from '@/components/advantages/advantages.vue';
import PublicationsBlock from '../components/news/publications-block';
import { commonGtmEvents } from '@/gtm/common-gtm-events';

export default {
  name: 'home',
  components: {
    PublicationsBlock,
    MainSlider,
    BannersSlot,
    ProductGallerySlot,
    CategoryBanners,
    Advantages,
  },

  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
      PRODUCTS: 'category/products',
      CITY: 'user/city',
    }),
  },

  mounted() {
    // Google Tag Manager event
    commonGtmEvents.viewMainPage({ cityName: this.CITY?.name });
    this.LOAD_PAGE_DATA({categoryUrl: '/catalog/muzhchiny/novinki'});
  },

  methods: {
    ...mapActions({
      LOAD_PAGE_DATA: 'category/loadCategoryPage',
    }),
  },

  serverPrefetch() {
    //return this.LOAD_PAGE_DATA({categoryUrl: '/catalog/muzhchiny/novinki'});
  },
};
</script>

<style lang="scss">
.home-page {
  &__bottom-offset {
    margin-bottom: $mobileOffset;

    @include breakpoint("desktop") {
      margin-bottom: $mobileOffsetDesktop;
    }
  }

  &__slider {
    margin-bottom: 26px;

    @include breakpoint("desktop") {
      margin-bottom: 36px;
    }
  }

  &__popular_main {
    margin-bottom: 15px;

    @include breakpoint("desktop") {
      margin-bottom: 35px;
    }
  }

  &__rowbanner2 {
    margin-bottom: 32px;

    @include breakpoint("desktop") {
      margin-bottom: 48px;
    }
  }

  &__advantages {
    margin-top: 16px;

    @include breakpoint("desktop") {
      margin-top: 50px;
    }
  }

  .publications-block {
    margin-top: 32px;
  }
}

@include breakpoint("desktop") {
  .home-page {
    .publications-block {
      margin-top: 56px;
    }
  }
}
</style>
